var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-label h-no-sel",class:{
    'active': _vm.active,
    'default': _vm.styling === 'default',
    'on-board': _vm.styling === 'on-board',
    'hide-on-top': _vm.hideTopLabel,
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }